import axios, { AxiosRequestConfig } from 'axios';

import { IPostgreJobsAnalyticsPayload } from '../../AnalyticsService';

const leadAnalyticsUrl = 'invoicingservice/api/composable-analytics/lead';

export const getPostgreLeadAnalyticsData = (
  payload: IPostgreJobsAnalyticsPayload,
  config?: AxiosRequestConfig
) => axios.post(`${leadAnalyticsUrl}/${payload.type}`, payload, config);
